import { useState } from "react";
import { useNavigate } from "react-router-dom";

import api from "../services/api";

function Login({ onLogin }) {
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setError("");
        setLoading(true);

        try {
            const response = await api.post(
                "/auth/login",
                {
                    username,
                    password
                }
            );

            const token = response.data.token;
            const user = response.data.user;

            localStorage.setItem(
                "token",
                token
            );

            localStorage.setItem(
                "user",
                JSON.stringify(user)
            );

            onLogin(token);

            navigate(
                "/dashboard",
                {
                    replace: true
                }
            );

        } catch (error) {
            setError(
                error.response?.data?.message ||
                "Unable to login"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-screen">

            <div className="login-header">
                <div className="logo-box">
                    PM
                </div>

                <h1>PriceManager</h1>

                <p>
                    Product price management
                </p>
            </div>


            <div className="login-card">

                <h2>Welcome back</h2>

                <p className="login-subtitle">
                    Sign in to continue
                </p>


                <form onSubmit={handleSubmit}>

                    <div className="form-group">

                        <label>
                            Username
                        </label>

                        <input
                            type="text"
                            placeholder="Enter username"
                            value={username}
                            onChange={(e) =>
                                setUsername(
                                    e.target.value
                                )
                            }
                            autoComplete="username"
                            required
                        />

                    </div>


                    <div className="form-group">

                        <label>
                            Password
                        </label>

                        <input
                            type="password"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) =>
                                setPassword(
                                    e.target.value
                                )
                            }
                            autoComplete="current-password"
                            required
                        />

                    </div>


                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}


                    <button
                        className="primary-button"
                        type="submit"
                        disabled={loading}
                    >
                        {
                            loading
                                ? "Signing in..."
                                : "Sign In"
                        }
                    </button>

                </form>

            </div>

        </div>
    );
}

export default Login;